export const agencyPlacesWidgetMap = [
  { fieldName: 'State', value: 'state' },
  { fieldName: 'City', value: 'city' },
  { fieldName: 'Address1', value: 'address1' },
  { fieldName: 'Address2', value: 'address2' },
  { fieldName: 'Zip', value: 'zip' },
  { fieldName: 'Name', value: 'name' },
  { fieldName: 'IdNumber', value: 'id' },
];

export const CounselingAgencyType = {
  EDUCATION_COUNSELING_AGENCY: 'homeownershipEducationHousingCounselingAgency',
  COUNSELING_AGENCY: 'housingCounselingAgency',
};

export const agencyPreviewInputProps = {
  variant: 'outlined',
  required: true,
  disabled: true,
};

export const searchByOptions = [
  { name: 'State/City', value: 'true' },
  { name: 'Zip', value: 'false' },
];
